<script setup lang="ts">
defineProps({
  dots: { type: Boolean }
})
</script>

<template>
  <div v-if="dots" class="spinner-dots">
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8.10231"
        cy="3.2381"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="11.4288"
        cy="4.67342"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="12.8642"
        cy="8"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="11.4288"
        cy="11.3672"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="8.10231"
        cy="12.7619"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="4.73511"
        cy="11.3672"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="3.3404"
        cy="8"
        r="1"
        fill="currentColor"
        class="dot"
      />
      <circle
        cx="4.7351"
        cy="4.67342"
        r="1"
        fill="currentColor"
        class="dot"
      />
    </svg>
  </div>
  <div v-else class="spinner" />
</template>

<style lang="sass" scoped>
.spinner-dots
  @apply w-4 h-4 text-[#{$global-bg-icon-secondary}]
  display: inline-block
  aspect-ratio: 1/1
  svg
    .dot
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite
    :nth-child(1)
      @apply animate-delay-0
    :nth-child(2)
      @apply animate-delay-250
    :nth-child(3)
      @apply animate-delay-500
    :nth-child(4)
      @apply animate-delay-750
    :nth-child(5)
      @apply animate-delay-1000
    :nth-child(6)
      @apply animate-delay-1250
    :nth-child(7)
      @apply animate-delay-1500
    :nth-child(8)
      @apply animate-delay-1750
@keyframes pulse
  35%
    opacity: 0.0
  60%
    opacity: 1

.spinner
  display: inline-block
  border-radius: 50%
  aspect-ratio: 1/1
  animation: 1s linear infinite spinning
  border: 1px solid currentcolor
  border-right-color: transparent
@keyframes spinning
  to
    transform: rotate(360deg)
</style>
